
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-1846 -132)"}},[_c('path',{attrs:{"fill":"#FBFAFC","d":"M0 0h1920v900H0z"}}),_c('path',{attrs:{"fill":"#593289","d":"M0 0h1920v902H0z"}}),_c('path',{attrs:{"fill":"#FBFAFC","d":"M50 50h1844a6 6 0 016 6v846H44V56a6 6 0 016-6z"}}),_c('rect',{attrs:{"width":"40","height":"148","x":"1838","y":"70","fill":"#F6F4F8","rx":"6"}}),_c('g',{attrs:{"transform":"translate(1849 135)"}},[_c('path',{attrs:{"d":"M4 8a1 1 0 102 0 1 1 0 00-2 0m1 3a1 1 0 100 2 1 1 0 000-2m4-4a1 1 0 100 2 1 1 0 000-2m0 4a1 1 0 100 2 1 1 0 000-2m4-4a1 1 0 100 2 1 1 0 000-2","fill":"#593289"}}),_c('path',{attrs:{"stroke":"#593289","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M5 0v4m8-4v4"}}),_c('rect',{attrs:{"width":"16.5","height":"15.5","x":".75","y":"1.75","stroke":"#593289","stroke-width":"1.5","rx":"2"}})])])])
          )
        }
      }
    